export const TOGGLE_NAVIGATION_DRAWER: string = 'TOGGLE_NAVIGATION_DRAWER';
export const TOGGLE_RIGHT_DRAWER: string = 'TOGGLE_RIGHT_DRAWER';
export const TOGGLE_RIGHT_DRAWER_TAB: string = 'TOGGLE_RIGHT_DRAWER_TAB';
export const TOGGLE_RIGHT_DRAWER_FIRST_TAB: string = 'TOGGLE_RIGHT_DRAWER_FIRST_TAB';
export const TOGGLE_EDIT_MODE: string = 'TOGGLE_EDIT_MODE';
export const TOGGLE_SELECT_MODE: string = 'TOGGLE_SELECT_MODE';
export const TOGGLE_EXPORT_MODE: string = 'TOGGLE_EXPORT_MODE';
export const TOGGLE_CUSTOMIZE_MODE: string = 'TOGGLE_CUSTOMIZE_MODE';
export const TOGGLE_CARD_VIEW: string = 'TOGGLE_CARD_VIEW';
export const TOGGLE_MODAL_EDIT_MODE: string = 'TOGGLE_MODAL_EDIT_MODE';

export const SET_STATUS_FILTER: string = 'SET_STATUS_FILTER';
export const SET_PORTFOLIO_IDS_FILTER: string = 'SET_PORTFOLIO_IDS_FILTER';
export const SET_PORTFOLIO_GROUP_IDS_FILTER: string = 'SET_PORTFOLIO_GROUP_IDS_FILTER';
export const SET_DEAL_SCHEDULE_ZOOM: string = 'SET_DEAL_SCHEDULE_ZOOM';

export const DELETE_FEED_ITEM: string = 'DELETE_FEED_ITEM';

export const RESET_FORM_ERRORS: string = 'RESET_FORM_ERRORS';
export const RESET_EXPORT_FILE: string = 'RESET_EXPORT_FILE';
export const RESET_PASSWORD_RECOVERED: string = 'RESET_PASSWORD_RECOVERED';
export const RESET_ACTION_HASH: string = 'RESET_ACTION_HASH';
export const RESET_BASE_DATA: string = 'RESET_BASE_DATA';
export const RESET_APP_LOADER: string = 'RESET_APP_LOADER';
export const RESET_ASSET_DATA: string = 'RESET_ASSET_DATA';
export const RESET_ACTIVITY_LIST_DATA: string = 'RESET_ACTIVITY_LIST_DATA';
export const RESET_ACTIVITY_DATA: string = 'RESET_ACTIVITY_DATA';
export const RESET_DEAL_DATA: string = 'RESET_DEAL_DATA';
export const RESET_DEAL_FILE_ANALYZED: string = 'RESET_DEAL_FILE_ANALYZED';
export const RESET_DEAL_FILE_CHAT_RESPONSE_TEXT: string = 'RESET_DEAL_FILE_CHAT_RESPONSE_TEXT';
export const RESET_DEAL_STATUS_CHANGE_LIST_DATA: string = 'RESET_DEAL_STATUS_CHANGE_LIST_DATA';
export const RESET_NEW_DEAL_ID: string = 'RESET_NEW_DEAL_ID';
export const RESET_CONTACT_DATA: string = 'RESET_CONTACT_DATA';
export const RESET_CONTACT_USER_DATA: string = 'RESET_CONTACT_USER_DATA';
export const RESET_CONTACT_VCARD_DATA: string = 'RESET_CONTACT_VCARD_DATA';
export const RESET_CONTACT_COMPANY_DATA: string = 'RESET_CONTACT_COMPANY_DATA';
export const RESET_CONTACT_PERSON_DATA: string = 'RESET_CONTACT_PERSON_DATA';
export const RESET_FEED_DATA: string = 'RESET_FEED_DATA';
export const RESET_SEARCH_RESULT_DATA: string = 'RESET_SEARCH_RESULT_DATA';
export const RESET_SEARCH_QUICK_RESULT_DATA: string = 'RESET_SEARCH_QUICK_RESULT_DATA';
export const RESET_USER_SETTINGS_DATA: string = 'RESET_USER_SETTINGS_DATA';
export const RESET_USER_SETTINGS_EXPORT_FILE: string = 'RESET_USER_SETTINGS_EXPORT_FILE';
export const RESET_OPERATION_LOG_DATA: string = 'RESET_OPERATION_LOG_DATA';
export const RESET_REPORT_DATA: string = 'RESET_REPORT_DATA';
export const RESET_REPORT_FILE: string = 'RESET_REPORT_FILE';
export const RESET_DEAL_CONNECTOR_AUTH_LINK: string = 'RESET_DEAL_CONNECTOR_AUTH_LINK';
export const RESET_ASSET_CONNECTOR_AUTH_LINK: string = 'RESET_ASSET_CONNECTOR_AUTH_LINK';
export const RESET_USER_API_KEY: string = 'RESET_USER_API_KEY';
export const RESET_USER_EMAIL_CONTACT_DATA: string = 'RESET_USER_EMAIL_CONTACT_DATA';
export const RESET_OPERATION_LOG_FILE_LINK: string = 'RESET_OPERATION_LOG_FILE_LINK';
export const RESET_DEAL_TEMPLATE_DATA: string = 'RESET_DEAL_TEMPLATE_DATA';

export const GET_ACCOUNT_OKTA_DATA: string = 'GET_ACCOUNT_OKTA_DATA';
export const GET_ACCOUNT_OKTA_DATA_SUCCESS: string = 'GET_ACCOUNT_OKTA_DATA_SUCCESS';
export const GET_ACCOUNT_OKTA_DATA_ERROR: string = 'GET_ACCOUNT_OKTA_DATA_ERROR';

export const LOGIN_USER: string = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS: string = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR: string = 'LOGIN_USER_ERROR';

export const VERIFY_USER: string = 'VERIFY_USER';
export const VERIFY_USER_SUCCESS: string = 'VERIFY_USER_SUCCESS';
export const VERIFY_USER_ERROR: string = 'VERIFY_USER_ERROR';

export const RESEND_VERIFICATION_CODE: string = 'RESEND_VERIFICATION_CODE';
export const RESEND_VERIFICATION_CODE_SUCCESS: string = 'RESEND_VERIFICATION_CODE_SUCCESS';
export const RESEND_VERIFICATION_CODE_ERROR: string = 'RESEND_VERIFICATION_CODE_ERROR';

export const GET_USER_REGISTRATION_DATA: string = 'GET_USER_REGISTRATION_DATA';
export const GET_USER_REGISTRATION_DATA_SUCCESS: string = 'GET_USER_REGISTRATION_DATA_SUCCESS';
export const GET_USER_REGISTRATION_DATA_ERROR: string = 'GET_USER_REGISTRATION_DATA_ERROR';

export const GET_USER_VERIFICATION_DATA: string = 'GET_USER_VERIFICATION_DATA';
export const GET_USER_VERIFICATION_DATA_SUCCESS: string = 'GET_USER_VERIFICATION_DATA_SUCCESS';
export const GET_USER_VERIFICATION_DATA_ERROR: string = 'GET_USER_VERIFICATION_DATA_ERROR';

export const GET_USER_VERIFICATION_SETUP_DATA: string = 'GET_USER_VERIFICATION_SETUP_DATA';
export const GET_USER_VERIFICATION_SETUP_DATA_SUCCESS: string = 'GET_USER_VERIFICATION_SETUP_DATA_SUCCESS';
export const GET_USER_VERIFICATION_SETUP_DATA_ERROR: string = 'GET_USER_VERIFICATION_SETUP_DATA_ERROR';

export const SAVE_USER_DATA: string = 'SAVE_USER_DATA';
export const SAVE_USER_DATA_SUCCESS: string = 'SAVE_USER_DATA_SUCCESS';
export const SAVE_USER_DATA_ERROR: string = 'SAVE_USER_DATA_ERROR';

export const RECOVER_PASSWORD: string = 'RECOVER_PASSWORD';
export const RECOVER_PASSWORD_SUCCESS: string = 'RECOVER_PASSWORD_SUCCESS';
export const RECOVER_PASSWORD_ERROR: string = 'RECOVER_PASSWORD_ERROR';

export const CHANGE_PASSWORD: string = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS: string = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR: string = 'CHANGE_PASSWORD_ERROR';

export const SEND_PHONE_VERIFICATION_CODE_SETUP: string = 'SEND_PHONE_VERIFICATION_CODE_SETUP';
export const SEND_PHONE_VERIFICATION_CODE_SETUP_SUCCESS: string = 'SEND_PHONE_VERIFICATION_CODE_SETUP_SUCCESS';
export const SEND_PHONE_VERIFICATION_CODE_SETUP_ERROR: string = 'SEND_PHONE_VERIFICATION_CODE_SETUP_ERROR';

export const VERIFY_USER_PHONE_SETUP: string = 'VERIFY_USER_PHONE_SETUP';
export const VERIFY_USER_PHONE_SETUP_SUCCESS: string = 'VERIFY_USER_PHONE_SETUP_SUCCESS';
export const VERIFY_USER_PHONE_SETUP_ERROR: string = 'VERIFY_USER_PHONE_SETUP_ERROR';

export const GENERATE_OTP_SECRET_DATA_SETUP: string = 'GENERATE_OTP_SECRET_DATA_SETUP';
export const GENERATE_OTP_SECRET_DATA_SETUP_SUCCESS: string = 'GENERATE_OTP_SECRET_DATA_SETUP_SUCCESS';
export const GENERATE_OTP_SECRET_DATA_SETUP_ERROR: string = 'GENERATE_OTP_SECRET_DATA_SETUP_ERROR';

export const VERIFY_USER_OTP_SETUP: string = 'VERIFY_USER_OTP_SETUP';
export const VERIFY_USER_OTP_SETUP_SUCCESS: string = 'VERIFY_USER_OTP_SETUP_SUCCESS';
export const VERIFY_USER_OTP_SETUP_ERROR: string = 'VERIFY_USER_OTP_SETUP_ERROR';

export const DELETE_OTP_SECRET_DATA_SETUP: string = 'DELETE_OTP_SECRET_DATA_SETUP';
export const DELETE_OTP_SECRET_DATA_SETUP_SUCCESS: string = 'DELETE_OTP_SECRET_DATA_SETUP_SUCCESS';
export const DELETE_OTP_SECRET_DATA_SETUP_ERROR: string = 'DELETE_OTP_SECRET_DATA_SETUP_ERROR';

export const SAVE_USER_VERIFICATION_DATA: string = 'SAVE_USER_VERIFICATION_DATA';
export const SAVE_USER_VERIFICATION_DATA_SUCCESS: string = 'SAVE_USER_VERIFICATION_DATA_SUCCESS';
export const SAVE_USER_VERIFICATION_DATA_ERROR: string = 'SAVE_USER_VERIFICATION_DATA_ERROR';

export const LOGOUT_USER: string = 'LOGOUT_USER';
export const LOGOUT_USER_SUCCESS: string = 'LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_ERROR: string = 'LOGOUT_USER_ERROR';

export const CLOSE_USER_SESSIONS: string = 'CLOSE_USER_SESSIONS';
export const CLOSE_USER_SESSIONS_SUCCESS: string = 'CLOSE_USER_SESSIONS_SUCCESS';
export const CLOSE_USER_SESSIONS_ERROR: string = 'CLOSE_USER_SESSIONS_ERROR';

export const COMMENT_ADDED: string = 'COMMENT_ADDED';
export const COMMENT_ADDED_SUCCESS: string = 'COMMENT_ADDED_SUCCESS';
export const COMMENT_ADDED_ERROR: string = 'COMMENT_ADDED_ERROR';

export const COMMENT_ADDED_SUBSCRIBED_SUCCESS: string = 'COMMENT_ADDED_SUBSCRIBED_SUCCESS';

export const NOTIFICATION_ADDED: string = 'NOTIFICATION_ADDED';
export const NOTIFICATION_ADDED_SUCCESS: string = 'NOTIFICATION_ADDED_SUCCESS';
export const NOTIFICATION_ADDED_ERROR: string = 'NOTIFICATION_ADDED_ERROR';

export const NOTIFICATION_ADDED_SUBSCRIBED_SUCCESS: string = 'NOTIFICATION_ADDED_SUBSCRIBED_SUCCESS';

export const USER_SESSION_EXPIRED: string = 'USER_SESSION_EXPIRED';
export const USER_SESSION_EXPIRED_SUCCESS: string = 'USER_SESSION_EXPIRED_SUCCESS';
export const USER_SESSION_EXPIRED_ERROR: string = 'USER_SESSION_EXPIRED_ERROR';

export const USER_SESSION_EXPIRED_SUBSCRIBED_SUCCESS: string = 'USER_SESSION_EXPIRED_SUBSCRIBED_SUCCESS';

export const VERIFY_PORTFOLIO_DEAL_EMAIL_CONNECTOR: string = 'VERIFY_PORTFOLIO_DEAL_EMAIL_CONNECTOR';
export const VERIFY_PORTFOLIO_DEAL_EMAIL_CONNECTOR_SUCCESS: string = 'VERIFY_PORTFOLIO_DEAL_EMAIL_CONNECTOR_SUCCESS';
export const VERIFY_PORTFOLIO_DEAL_EMAIL_CONNECTOR_ERROR: string = 'VERIFY_PORTFOLIO_DEAL_EMAIL_CONNECTOR_ERROR';

export const VERIFY_ACCOUNT_ASSET_EMAIL_CONNECTOR: string = 'VERIFY_ACCOUNT_ASSET_EMAIL_CONNECTOR';
export const VERIFY_ACCOUNT_ASSET_EMAIL_CONNECTOR_SUCCESS: string = 'VERIFY_ACCOUNT_ASSET_EMAIL_CONNECTOR_SUCCESS';
export const VERIFY_ACCOUNT_ASSET_EMAIL_CONNECTOR_ERROR: string = 'VERIFY_ACCOUNT_ASSET_EMAIL_CONNECTOR_ERROR';

export const SEND_PHONE_VERIFICATION_CODE: string = 'SEND_PHONE_VERIFICATION_CODE';
export const SEND_PHONE_VERIFICATION_CODE_SUCCESS: string = 'SEND_PHONE_VERIFICATION_CODE_SUCCESS';
export const SEND_PHONE_VERIFICATION_CODE_ERROR: string = 'SEND_PHONE_VERIFICATION_CODE_ERROR';

export const VERIFY_USER_PHONE: string = 'VERIFY_USER_PHONE';
export const VERIFY_USER_PHONE_SUCCESS: string = 'VERIFY_USER_PHONE_SUCCESS';
export const VERIFY_USER_PHONE_ERROR: string = 'VERIFY_USER_PHONE_ERROR';

export const GENERATE_OTP_SECRET_DATA: string = 'GENERATE_OTP_SECRET_DATA';
export const GENERATE_OTP_SECRET_DATA_SUCCESS: string = 'GENERATE_OTP_SECRET_DATA_SUCCESS';
export const GENERATE_OTP_SECRET_DATA_ERROR: string = 'GENERATE_OTP_SECRET_DATA_ERROR';

export const DELETE_OTP_SECRET_DATA: string = 'DELETE_OTP_SECRET_DATA';
export const DELETE_OTP_SECRET_DATA_SUCCESS: string = 'DELETE_OTP_SECRET_DATA_SUCCESS';
export const DELETE_OTP_SECRET_DATA_ERROR: string = 'DELETE_OTP_SECRET_DATA_ERROR';

export const GET_OTP_SECRET_DATA: string = 'GET_OTP_SECRET_DATA';
export const GET_OTP_SECRET_DATA_SUCCESS: string = 'GET_OTP_SECRET_DATA_SUCCESS';
export const GET_OTP_SECRET_DATA_ERROR: string = 'GET_OTP_SECRET_DATA_ERROR';

export const VERIFY_USER_OTP: string = 'VERIFY_USER_OTP';
export const VERIFY_USER_OTP_SUCCESS: string = 'VERIFY_USER_OTP_SUCCESS';
export const VERIFY_USER_OTP_ERROR: string = 'VERIFY_USER_OTP_ERROR';

export const SAVE_USER_PUSH_NOTIFICATION_TOKEN: string = 'SAVE_USER_PUSH_NOTIFICATION_TOKEN';
export const SAVE_USER_PUSH_NOTIFICATION_TOKEN_SUCCESS: string = 'SAVE_USER_PUSH_NOTIFICATION_TOKEN_SUCCESS';
export const SAVE_USER_PUSH_NOTIFICATION_TOKEN_ERROR: string = 'SAVE_USER_PUSH_NOTIFICATION_TOKEN_ERROR';

export const INVITE_USER: string = 'INVITE_USER';
export const INVITE_USER_SUCCESS: string = 'INVITE_USER_SUCCESS';
export const INVITE_USER_ERROR: string = 'INVITE_USER_ERROR';

export const EXPORT_DATA: string = 'EXPORT_DATA';
export const EXPORT_DATA_SUCCESS: string = 'EXPORT_DATA_SUCCESS';
export const EXPORT_DATA_ERROR: string = 'EXPORT_DATA_ERROR';

export const IMPORT_DATA: string = 'IMPORT_DATA';
export const IMPORT_DATA_SUCCESS: string = 'IMPORT_DATA_SUCCESS';
export const IMPORT_DATA_ERROR: string = 'IMPORT_DATA_ERROR';

export const GENERATE_REPORT_DATA: string = 'GENERATE_REPORT_DATA';
export const GENERATE_REPORT_DATA_SUCCESS: string = 'GENERATE_REPORT_DATA_SUCCESS';
export const GENERATE_REPORT_DATA_ERROR: string = 'GENERATE_REPORT_DATA_ERROR';

export const READ_COMMENTS: string = 'READ_COMMENTS';
export const READ_COMMENTS_SUCCESS: string = 'READ_COMMENTS_SUCCESS';
export const READ_COMMENTS_ERROR: string = 'READ_COMMENTS_ERROR';

export const READ_NOTIFICATIONS: string = 'READ_NOTIFICATIONS';
export const READ_NOTIFICATIONS_SUCCESS: string = 'READ_NOTIFICATIONS_SUCCESS';
export const READ_NOTIFICATIONS_ERROR: string = 'READ_NOTIFICATIONS_ERROR';

export const VIEW_DEAL_FILE: string = 'VIEW_DEAL_FILE';
export const VIEW_DEAL_FILE_SUCCESS: string = 'VIEW_DEAL_FILE_SUCCESS';
export const VIEW_DEAL_FILE_ERROR: string = 'VIEW_DEAL_FILE_ERROR';

export const RESET_USER_SETTINGS: string = 'RESET_USER_SETTINGS';
export const RESET_USER_SETTINGS_SUCCESS: string = 'RESET_USER_SETTINGS_SUCCESS';
export const RESET_USER_SETTINGS_ERROR: string = 'RESET_USER_SETTINGS_ERROR';

export const EXPORT_USER_SETTINGS: string = 'EXPORT_USER_SETTINGS';
export const EXPORT_USER_SETTINGS_SUCCESS: string = 'EXPORT_USER_SETTINGS_SUCCESS';
export const EXPORT_USER_SETTINGS_ERROR: string = 'EXPORT_USER_SETTINGS_ERROR';

export const IMPORT_USER_SETTINGS: string = 'IMPORT_USER_SETTINGS';
export const IMPORT_USER_SETTINGS_SUCCESS: string = 'IMPORT_USER_SETTINGS_SUCCESS';
export const IMPORT_USER_SETTINGS_ERROR: string = 'IMPORT_USER_SETTINGS_ERROR';

export const DEACTIVATE_USER: string = 'DEACTIVATE_USER';
export const DEACTIVATE_USER_SUCCESS: string = 'DEACTIVATE_USER_SUCCESS';
export const DEACTIVATE_USER_ERROR: string = 'DEACTIVATE_USER_ERROR';

export const RESET_USER_PASSWORD: string = 'RESET_USER_PASSWORD';
export const RESET_USER_PASSWORD_SUCCESS: string = 'RESET_USER_PASSWORD_SUCCESS';
export const RESET_USER_PASSWORD_ERROR: string = 'RESET_USER_PASSWORD_ERROR';

export const SEND_ACCOUNT_NOTIFICATION: string = 'SEND_ACCOUNT_NOTIFICATION';
export const SEND_ACCOUNT_NOTIFICATION_SUCCESS: string = 'SEND_ACCOUNT_NOTIFICATION_SUCCESS';
export const SEND_ACCOUNT_NOTIFICATION_ERROR: string = 'SEND_ACCOUNT_NOTIFICATION_ERROR';

export const GET_BASE_DATA: string = 'GET_BASE_DATA';
export const GET_BASE_DATA_SUCCESS: string = 'GET_BASE_DATA_SUCCESS';
export const GET_BASE_DATA_ERROR: string = 'GET_BASE_DATA_ERROR';

export const GET_LIST_ACTIVITY_DEAL_DATA: string = 'GET_LIST_ACTIVITY_DEAL_DATA';
export const GET_LIST_ACTIVITY_DEAL_DATA_SUCCESS: string = 'GET_LIST_ACTIVITY_DEAL_DATA_SUCCESS';
export const GET_LIST_ACTIVITY_DEAL_DATA_ERROR: string = 'GET_LIST_ACTIVITY_DEAL_DATA_ERROR';

export const GET_LIST_CONTACT_DATA: string = 'GET_LIST_CONTACT_DATA';
export const GET_LIST_CONTACT_DATA_SUCCESS: string = 'GET_LIST_CONTACT_DATA_SUCCESS';
export const GET_LIST_CONTACT_DATA_ERROR: string = 'GET_LIST_CONTACT_DATA_ERROR';

export const GET_LIST_CONTACT_COMPANY_DATA: string = 'GET_LIST_CONTACT_COMPANY_DATA';
export const GET_LIST_CONTACT_COMPANY_DATA_SUCCESS: string = 'GET_LIST_CONTACT_COMPANY_DATA_SUCCESS';
export const GET_LIST_CONTACT_COMPANY_DATA_ERROR: string = 'GET_LIST_CONTACT_COMPANY_DATA_ERROR';

export const GET_LIST_CONTACT_PERSON_DATA: string = 'GET_LIST_CONTACT_PERSON_DATA';
export const GET_LIST_CONTACT_PERSON_DATA_SUCCESS: string = 'GET_LIST_CONTACT_PERSON_DATA_SUCCESS';
export const GET_LIST_CONTACT_PERSON_DATA_ERROR: string = 'GET_LIST_CONTACT_PERSON_DATA_ERROR';

export const GET_LIST_CONTACT_PERSON_INTERNAL_DATA: string = 'GET_LIST_CONTACT_PERSON_INTERNAL_DATA';
export const GET_LIST_CONTACT_PERSON_INTERNAL_DATA_SUCCESS: string = 'GET_LIST_CONTACT_PERSON_INTERNAL_DATA_SUCCESS';
export const GET_LIST_CONTACT_PERSON_INTERNAL_DATA_ERROR: string = 'GET_LIST_CONTACT_PERSON_INTERNAL_DATA_ERROR';

export const GET_LIST_CONTACT_NOT_PARTICIPANT_DATA: string = 'GET_LIST_CONTACT_NOT_PARTICIPANT_DATA';
export const GET_LIST_CONTACT_NOT_PARTICIPANT_DATA_SUCCESS: string = 'GET_LIST_CONTACT_NOT_PARTICIPANT_DATA_SUCCESS';
export const GET_LIST_CONTACT_NOT_PARTICIPANT_DATA_ERROR: string = 'GET_LIST_CONTACT_NOT_PARTICIPANT_DATA_ERROR';

export const GET_LIST_DEAL_TASK_CONTACT_PERSON_DATA: string = 'GET_LIST_DEAL_TASK_CONTACT_PERSON_DATA';
export const GET_LIST_DEAL_TASK_CONTACT_PERSON_DATA_SUCCESS: string = 'GET_LIST_DEAL_TASK_CONTACT_PERSON_DATA_SUCCESS';
export const GET_LIST_DEAL_TASK_CONTACT_PERSON_DATA_ERROR: string = 'GET_LIST_DEAL_TASK_CONTACT_PERSON_DATA_ERROR';

export const GET_LIST_DEAL_ASSET_DATA: string = 'GET_LIST_DEAL_ASSET_DATA';
export const GET_LIST_DEAL_ASSET_DATA_SUCCESS: string = 'GET_LIST_DEAL_ASSET_DATA_SUCCESS';
export const GET_LIST_DEAL_ASSET_DATA_ERROR: string = 'GET_LIST_DEAL_ASSET_DATA_ERROR';

export const GET_LIST_DEAL_DATA: string = 'GET_LIST_DEAL_DATA';
export const GET_LIST_DEAL_DATA_SUCCESS: string = 'GET_LIST_DEAL_DATA_SUCCESS';
export const GET_LIST_DEAL_DATA_ERROR: string = 'GET_LIST_DEAL_DATA_ERROR';

export const GET_LIST_NOT_LINKED_USER_DATA: string = 'GET_LIST_NOT_LINKED_USER_DATA';
export const GET_LIST_NOT_LINKED_USER_DATA_SUCCESS: string = 'GET_LIST_NOT_LINKED_USER_DATA_SUCCESS';
export const GET_LIST_NOT_LINKED_USER_DATA_ERROR: string = 'GET_LIST_NOT_LINKED_USER_DATA_ERROR';

export const GET_LIST_TAG_DATA: string = 'GET_LIST_TAG_DATA';
export const GET_LIST_TAG_DATA_SUCCESS: string = 'GET_LIST_TAG_DATA_SUCCESS';
export const GET_LIST_TAG_DATA_ERROR: string = 'GET_LIST_TAG_DATA_ERROR';

export const GET_COMMENT_LIST_DATA: string = 'GET_COMMENT_LIST_DATA';
export const GET_COMMENT_LIST_DATA_SUCCESS: string = 'GET_COMMENT_LIST_DATA_SUCCESS';
export const GET_COMMENT_LIST_DATA_ERROR: string = 'GET_COMMENT_LIST_DATA_ERROR';

export const GET_NOTIFICATION_LIST_DATA: string = 'GET_NOTIFICATION_LIST_DATA';
export const GET_NOTIFICATION_LIST_DATA_SUCCESS: string = 'GET_NOTIFICATION_LIST_DATA_SUCCESS';
export const GET_NOTIFICATION_LIST_DATA_ERROR: string = 'GET_NOTIFICATION_LIST_DATA_ERROR';

export const GET_DASHBOARD_DATA: string = 'GET_DASHBOARD_DATA';
export const GET_DASHBOARD_DATA_SUCCESS: string = 'GET_DASHBOARD_DATA_SUCCESS';
export const GET_DASHBOARD_DATA_ERROR: string = 'GET_DASHBOARD_DATA_ERROR';

export const GET_SETTINGS_DATA: string = 'GET_SETTINGS_DATA';
export const GET_SETTINGS_DATA_SUCCESS: string = 'GET_SETTINGS_DATA_SUCCESS';
export const GET_SETTINGS_DATA_ERROR: string = 'GET_SETTINGS_DATA_ERROR';

export const GET_ACCOUNT_LIST_DATA: string = 'GET_ACCOUNT_LIST_DATA';
export const GET_ACCOUNT_LIST_DATA_SUCCESS: string = 'GET_ACCOUNT_LIST_DATA_SUCCESS';
export const GET_ACCOUNT_LIST_DATA_ERROR: string = 'GET_ACCOUNT_LIST_DATA_ERROR';

export const GET_ACCOUNT_ASSET_EMAIL_CONNECTOR_DATA: string = 'GET_ACCOUNT_ASSET_EMAIL_CONNECTOR_DATA';
export const GET_ACCOUNT_ASSET_EMAIL_CONNECTOR_DATA_SUCCESS: string = 'GET_ACCOUNT_ASSET_EMAIL_CONNECTOR_DATA_SUCCESS';
export const GET_ACCOUNT_ASSET_EMAIL_CONNECTOR_DATA_ERROR: string = 'GET_ACCOUNT_ASSET_EMAIL_CONNECTOR_DATA_ERROR';

export const GET_DEAL_TEMPLATE_LIST_DATA: string = 'GET_DEAL_TEMPLATE_LIST_DATA';
export const GET_DEAL_TEMPLATE_LIST_DATA_SUCCESS: string = 'GET_DEAL_TEMPLATE_LIST_DATA_SUCCESS';
export const GET_DEAL_TEMPLATE_LIST_DATA_ERROR: string = 'GET_DEAL_TEMPLATE_LIST_DATA_ERROR';

export const GET_DEAL_TEMPLATE_DATA: string = 'GET_DEAL_TEMPLATE_DATA';
export const GET_DEAL_TEMPLATE_DATA_SUCCESS: string = 'GET_DEAL_TEMPLATE_DATA_SUCCESS';
export const GET_DEAL_TEMPLATE_DATA_ERROR: string = 'GET_DEAL_TEMPLATE_DATA_ERROR';

export const GET_PORTFOLIO_GROUP_LIST_DATA: string = 'GET_PORTFOLIO_GROUP_LIST_DATA';
export const GET_PORTFOLIO_GROUP_LIST_DATA_SUCCESS: string = 'GET_PORTFOLIO_GROUP_LIST_DATA_SUCCESS';
export const GET_PORTFOLIO_GROUP_LIST_DATA_ERROR: string = 'GET_PORTFOLIO_GROUP_LIST_DATA_ERROR';

export const GET_PORTFOLIO_GROUP_DATA: string = 'GET_PORTFOLIO_GROUP_DATA';
export const GET_PORTFOLIO_GROUP_DATA_SUCCESS: string = 'GET_PORTFOLIO_GROUP_DATA_SUCCESS';
export const GET_PORTFOLIO_GROUP_DATA_ERROR: string = 'GET_PORTFOLIO_GROUP_DATA_ERROR';

export const GET_PORTFOLIO_DEAL_EMAIL_CONNECTOR_DATA: string = 'GET_PORTFOLIO_DEAL_EMAIL_CONNECTOR_DATA';
export const GET_PORTFOLIO_DEAL_EMAIL_CONNECTOR_DATA_SUCCESS: string
  = 'GET_PORTFOLIO_DEAL_EMAIL_CONNECTOR_DATA_SUCCESS';
export const GET_PORTFOLIO_DEAL_EMAIL_CONNECTOR_DATA_ERROR: string = 'GET_PORTFOLIO_DEAL_EMAIL_CONNECTOR_DATA_ERROR';

export const GET_PORTFOLIO_DATA: string = 'GET_PORTFOLIO_DATA';
export const GET_PORTFOLIO_DATA_SUCCESS: string = 'GET_PORTFOLIO_DATA_SUCCESS';
export const GET_PORTFOLIO_DATA_ERROR: string = 'GET_PORTFOLIO_DATA_ERROR';

export const GET_USER_LIST_DATA: string = 'GET_USER_LIST_DATA';
export const GET_USER_LIST_DATA_SUCCESS: string = 'GET_USER_LIST_DATA_SUCCESS';
export const GET_USER_LIST_DATA_ERROR: string = 'GET_USER_LIST_DATA_ERROR';

export const GET_USER_SETTINGS_DATA: string = 'GET_USER_SETTINGS_DATA';
export const GET_USER_SETTINGS_DATA_SUCCESS: string = 'GET_USER_SETTINGS_DATA_SUCCESS';
export const GET_USER_SETTINGS_DATA_ERROR: string = 'GET_USER_SETTINGS_DATA_ERROR';

export const GET_USER_EMAIL_CONTACT_DATA: string = 'GET_USER_EMAIL_CONTACT_DATA';
export const GET_USER_EMAIL_CONTACT_DATA_SUCCESS: string = 'GET_USER_EMAIL_CONTACT_DATA_SUCCESS';
export const GET_USER_EMAIL_CONTACT_DATA_ERROR: string = 'GET_USER_EMAIL_CONTACT_DATA_ERROR';

export const GET_USER_API_KEY: string = 'GET_USER_API_KEY';
export const GET_USER_API_KEY_SUCCESS: string = 'GET_USER_API_KEY_SUCCESS';
export const GET_USER_API_KEY_ERROR: string = 'GET_USER_API_KEY_ERROR';

export const GET_OPERATION_LOG_DATA: string = 'GET_OPERATION_LOG_DATA';
export const GET_OPERATION_LOG_DATA_SUCCESS: string = 'GET_OPERATION_LOG_DATA_SUCCESS';
export const GET_OPERATION_LOG_DATA_ERROR: string = 'GET_OPERATION_LOG_DATA_ERROR';

export const GET_USER_OPERATION_LIST_DATA: string = 'GET_USER_OPERATION_LIST_DATA';
export const GET_USER_OPERATION_LIST_DATA_SUCCESS: string = 'GET_USER_OPERATION_LIST_DATA_SUCCESS';
export const GET_USER_OPERATION_LIST_DATA_ERROR: string = 'GET_USER_OPERATION_LIST_DATA_ERROR';

export const GET_EMAIL_OPERATION_LIST_DATA: string = 'GET_EMAIL_OPERATION_LIST_DATA';
export const GET_EMAIL_OPERATION_LIST_DATA_SUCCESS: string = 'GET_EMAIL_OPERATION_LIST_DATA_SUCCESS';
export const GET_EMAIL_OPERATION_LIST_DATA_ERROR: string = 'GET_EMAIL_OPERATION_LIST_DATA_ERROR';

export const GET_DEAL_OPERATION_LIST_DATA: string = 'GET_DEAL_OPERATION_LIST_DATA';
export const GET_DEAL_OPERATION_LIST_DATA_SUCCESS: string = 'GET_DEAL_OPERATION_LIST_DATA_SUCCESS';
export const GET_DEAL_OPERATION_LIST_DATA_ERROR: string = 'GET_DEAL_OPERATION_LIST_DATA_ERROR';

export const GET_API_OPERATION_LIST_DATA: string = 'GET_API_OPERATION_LIST_DATA';
export const GET_API_OPERATION_LIST_DATA_SUCCESS: string = 'GET_API_OPERATION_LIST_DATA_SUCCESS';
export const GET_API_OPERATION_LIST_DATA_ERROR: string = 'GET_API_OPERATION_LIST_DATA_ERROR';

export const GET_API_OPERATION_DATA: string = 'GET_API_OPERATION_DATA';
export const GET_API_OPERATION_DATA_SUCCESS: string = 'GET_API_OPERATION_DATA_SUCCESS';
export const GET_API_OPERATION_DATA_ERROR: string = 'GET_API_OPERATION_DATA_ERROR';

export const GET_REPORT_OPERATION_LIST_DATA: string = 'GET_REPORT_OPERATION_LIST_DATA';
export const GET_REPORT_OPERATION_LIST_DATA_SUCCESS: string = 'GET_REPORT_OPERATION_LIST_DATA_SUCCESS';
export const GET_REPORT_OPERATION_LIST_DATA_ERROR: string = 'GET_REPORT_OPERATION_LIST_DATA_ERROR';

export const GET_ERROR_MESSAGE_LIST_DATA: string = 'GET_ERROR_MESSAGE_LIST_DATA';
export const GET_ERROR_MESSAGE_LIST_DATA_SUCCESS: string = 'GET_ERROR_MESSAGE_LIST_DATA_SUCCESS';
export const GET_ERROR_MESSAGE_LIST_DATA_ERROR: string = 'GET_ERROR_MESSAGE_LIST_DATA_ERROR';

export const GET_SEARCH_RESULT_DATA: string = 'GET_SEARCH_RESULT_DATA';
export const GET_SEARCH_RESULT_DATA_SUCCESS: string = 'GET_SEARCH_RESULT_DATA_SUCCESS';
export const GET_SEARCH_RESULT_DATA_ERROR: string = 'GET_SEARCH_RESULT_DATA_ERROR';

export const GET_SEARCH_QUICK_RESULT_DATA: string = 'GET_SEARCH_QUICK_RESULT_DATA';
export const GET_SEARCH_QUICK_RESULT_DATA_SUCCESS: string = 'GET_SEARCH_QUICK_RESULT_DATA_SUCCESS';
export const GET_SEARCH_QUICK_RESULT_DATA_ERROR: string = 'GET_SEARCH_QUICK_RESULT_DATA_ERROR';

export const GET_ASSET_LIST_DATA: string = 'GET_ASSET_LIST_DATA';
export const GET_ASSET_LIST_DATA_SUCCESS: string = 'GET_ASSET_LIST_DATA_SUCCESS';
export const GET_ASSET_LIST_DATA_ERROR: string = 'GET_ASSET_LIST_DATA_ERROR';

export const GET_ASSET_DATA: string = 'GET_ASSET_DATA';
export const GET_ASSET_DATA_SUCCESS: string = 'GET_ASSET_DATA_SUCCESS';
export const GET_ASSET_DATA_ERROR: string = 'GET_ASSET_DATA_ERROR';

export const GET_ACTIVITY_LIST_DATA: string = 'GET_ACTIVITY_LIST_DATA';
export const GET_ACTIVITY_LIST_DATA_SUCCESS: string = 'GET_ACTIVITY_LIST_DATA_SUCCESS';
export const GET_ACTIVITY_LIST_DATA_ERROR: string = 'GET_ACTIVITY_LIST_DATA_ERROR';

export const GET_ACTIVITY_DATA: string = 'GET_ACTIVITY_DATA';
export const GET_ACTIVITY_DATA_SUCCESS: string = 'GET_ACTIVITY_DATA_SUCCESS';
export const GET_ACTIVITY_DATA_ERROR: string = 'GET_ACTIVITY_DATA_ERROR';

export const GET_DEAL_LIST_DATA: string = 'GET_DEAL_LIST_DATA';
export const GET_DEAL_LIST_DATA_SUCCESS: string = 'GET_DEAL_LIST_DATA_SUCCESS';
export const GET_DEAL_LIST_DATA_ERROR: string = 'GET_DEAL_LIST_DATA_ERROR';

export const GET_DEAL_DATA: string = 'GET_DEAL_DATA';
export const GET_DEAL_DATA_SUCCESS: string = 'GET_DEAL_DATA_SUCCESS';
export const GET_DEAL_DATA_ERROR: string = 'GET_DEAL_DATA_ERROR';

export const GET_DEAL_DATA_BY_FILE: string = 'GET_DEAL_DATA_BY_FILE';
export const GET_DEAL_DATA_BY_FILE_SUCCESS: string = 'GET_DEAL_DATA_BY_FILE_SUCCESS';
export const GET_DEAL_DATA_BY_FILE_ERROR: string = 'GET_DEAL_DATA_BY_FILE_ERROR';

export const GET_DEAL_STATUS_CHANGE_LIST_DATA: string = 'GET_DEAL_STATUS_CHANGE_LIST_DATA';
export const GET_DEAL_STATUS_CHANGE_LIST_DATA_SUCCESS: string = 'GET_DEAL_STATUS_CHANGE_LIST_DATA_SUCCESS';
export const GET_DEAL_STATUS_CHANGE_LIST_DATA_ERROR: string = 'GET_DEAL_STATUS_CHANGE_LIST_DATA_ERROR';

export const GET_DEAL_TASK_LIST_DATA: string = 'GET_DEAL_TASK_LIST_DATA';
export const GET_DEAL_TASK_LIST_DATA_SUCCESS: string = 'GET_DEAL_TASK_LIST_DATA_SUCCESS';
export const GET_DEAL_TASK_LIST_DATA_ERROR: string = 'GET_DEAL_TASK_LIST_DATA_ERROR';

export const GET_DEAL_TASK_ATTACHMENT_TEXT_DATA: string = 'GET_DEAL_TASK_ATTACHMENT_TEXT_DATA';
export const GET_DEAL_TASK_ATTACHMENT_TEXT_DATA_SUCCESS: string = 'GET_DEAL_TASK_ATTACHMENT_TEXT_DATA_SUCCESS';
export const GET_DEAL_TASK_ATTACHMENT_TEXT_DATA_ERROR: string = 'GET_DEAL_TASK_ATTACHMENT_TEXT_DATA_ERROR';

export const GET_DEAL_FILE_LIST_DATA: string = 'GET_DEAL_FILE_LIST_DATA';
export const GET_DEAL_FILE_LIST_DATA_SUCCESS: string = 'GET_DEAL_FILE_LIST_DATA_SUCCESS';
export const GET_DEAL_FILE_LIST_DATA_ERROR: string = 'GET_DEAL_FILE_LIST_DATA_ERROR';

export const GET_DEAL_FILE_TEXT_DATA: string = 'GET_DEAL_FILE_TEXT_DATA';
export const GET_DEAL_FILE_TEXT_DATA_SUCCESS: string = 'GET_DEAL_FILE_TEXT_DATA_SUCCESS';
export const GET_DEAL_FILE_TEXT_DATA_ERROR: string = 'GET_DEAL_FILE_TEXT_DATA_ERROR';

export const GET_DEAL_PARTICIPANT_LIST_DATA: string = 'GET_DEAL_PARTICIPANT_LIST_DATA';
export const GET_DEAL_PARTICIPANT_LIST_DATA_SUCCESS: string = 'GET_DEAL_PARTICIPANT_LIST_DATA_SUCCESS';
export const GET_DEAL_PARTICIPANT_LIST_DATA_ERROR: string = 'GET_DEAL_PARTICIPANT_LIST_DATA_ERROR';

export const GET_CONTACT_LIST_DATA: string = 'GET_CONTACT_LIST_DATA';
export const GET_CONTACT_LIST_DATA_SUCCESS: string = 'GET_CONTACT_LIST_DATA_SUCCESS';
export const GET_CONTACT_LIST_DATA_ERROR: string = 'GET_CONTACT_LIST_DATA_ERROR';

export const GET_CONTACT_DATA: string = 'GET_CONTACT_DATA';
export const GET_CONTACT_DATA_SUCCESS: string = 'GET_CONTACT_DATA_SUCCESS';
export const GET_CONTACT_DATA_ERROR: string = 'GET_CONTACT_DATA_ERROR';

export const GET_CONTACT_USER_DATA: string = 'GET_CONTACT_USER_DATA';
export const GET_CONTACT_USER_DATA_SUCCESS: string = 'GET_CONTACT_USER_DATA_SUCCESS';
export const GET_CONTACT_USER_DATA_ERROR: string = 'GET_CONTACT_USER_DATA_ERROR';

export const GET_CONTACT_VCARD_DATA: string = 'GET_CONTACT_VCARD_DATA';
export const GET_CONTACT_VCARD_DATA_SUCCESS: string = 'GET_CONTACT_VCARD_DATA_SUCCESS';
export const GET_CONTACT_VCARD_DATA_ERROR: string = 'GET_CONTACT_VCARD_DATA_ERROR';

export const GET_CONTACT_RELATED_CONTACT_LIST_DATA: string = 'GET_CONTACT_RELATED_CONTACT_LIST_DATA';
export const GET_CONTACT_RELATED_CONTACT_LIST_DATA_SUCCESS: string = 'GET_CONTACT_RELATED_CONTACT_LIST_DATA_SUCCESS';
export const GET_CONTACT_RELATED_CONTACT_LIST_DATA_ERROR: string = 'GET_CONTACT_RELATED_CONTACT_LIST_DATA_ERROR';

export const GET_CONTACT_DEAL_LIST_DATA: string = 'GET_CONTACT_DEAL_LIST_DATA';
export const GET_CONTACT_DEAL_LIST_DATA_SUCCESS: string = 'GET_CONTACT_DEAL_LIST_DATA_SUCCESS';
export const GET_CONTACT_DEAL_LIST_DATA_ERROR: string = 'GET_CONTACT_DEAL_LIST_DATA_ERROR';

export const GET_CONTACT_COMPANY_BY_DOMAIN_DATA: string = 'GET_CONTACT_COMPANY_BY_DOMAIN_DATA';
export const GET_CONTACT_COMPANY_BY_DOMAIN_DATA_SUCCESS: string = 'GET_CONTACT_COMPANY_BY_DOMAIN_DATA_SUCCESS';
export const GET_CONTACT_COMPANY_BY_DOMAIN_DATA_ERROR: string = 'GET_CONTACT_COMPANY_BY_DOMAIN_DATA_ERROR';

export const GET_CONTACT_PERSON_BY_EMAIL_DATA: string = 'GET_CONTACT_PERSON_BY_EMAIL_DATA';
export const GET_CONTACT_PERSON_BY_EMAIL_DATA_SUCCESS: string = 'GET_CONTACT_PERSON_BY_EMAIL_DATA_SUCCESS';
export const GET_CONTACT_PERSON_BY_EMAIL_DATA_ERROR: string = 'GET_CONTACT_PERSON_BY_EMAIL_DATA_ERROR';

export const GET_REPORT_LIST_DATA: string = 'GET_REPORT_LIST_DATA';
export const GET_REPORT_LIST_DATA_SUCCESS: string = 'GET_REPORT_LIST_DATA_SUCCESS';
export const GET_REPORT_LIST_DATA_ERROR: string = 'GET_REPORT_LIST_DATA_ERROR';

export const GET_REPORT_DATA: string = 'GET_REPORT_DATA';
export const GET_REPORT_DATA_SUCCESS: string = 'GET_REPORT_DATA_SUCCESS';
export const GET_REPORT_DATA_ERROR: string = 'GET_REPORT_DATA_ERROR';

export const SAVE_TABLE_COLUMN_SETTINGS: string = 'SAVE_TABLE_COLUMN_SETTINGS';
export const SAVE_TABLE_COLUMN_SETTINGS_SUCCESS: string = 'SAVE_TABLE_COLUMN_SETTINGS_SUCCESS';
export const SAVE_TABLE_COLUMN_SETTINGS_ERROR: string = 'SAVE_TABLE_COLUMN_SETTINGS_ERROR';

export const SAVE_WIDGET_SETTINGS: string = 'SAVE_WIDGET_SETTINGS';
export const SAVE_WIDGET_SETTINGS_SUCCESS: string = 'SAVE_WIDGET_SETTINGS_SUCCESS';
export const SAVE_WIDGET_SETTINGS_ERROR: string = 'SAVE_WIDGET_SETTINGS_ERROR';

export const SAVE_DEAL_TAB_SETTINGS: string = 'SAVE_DEAL_TAB_SETTINGS';
export const SAVE_DEAL_TAB_SETTINGS_SUCCESS: string = 'SAVE_DEAL_TAB_SETTINGS_SUCCESS';
export const SAVE_DEAL_TAB_SETTINGS_ERROR: string = 'SAVE_DEAL_TAB_SETTINGS_ERROR';

export const SAVE_PORTFOLIO_ORDER_SETTINGS: string = 'SAVE_PORTFOLIO_ORDER_SETTINGS';
export const SAVE_PORTFOLIO_ORDER_SETTINGS_SUCCESS: string = 'SAVE_PORTFOLIO_ORDER_SETTINGS_SUCCESS';
export const SAVE_PORTFOLIO_ORDER_SETTINGS_ERROR: string = 'SAVE_PORTFOLIO_ORDER_SETTINGS_ERROR';

export const SAVE_DEAL_TASK_GROUP_ORDER_SETTINGS: string = 'SAVE_DEAL_TASK_GROUP_ORDER_SETTINGS';
export const SAVE_DEAL_TASK_GROUP_ORDER_SETTINGS_SUCCESS: string = 'SAVE_DEAL_TASK_GROUP_ORDER_SETTINGS_SUCCESS';
export const SAVE_DEAL_TASK_GROUP_ORDER_SETTINGS_ERROR: string = 'SAVE_DEAL_TASK_GROUP_ORDER_SETTINGS_ERROR';

export const SAVE_DEAL_FILE_GROUP_ORDER_SETTINGS: string = 'SAVE_DEAL_FILE_GROUP_ORDER_SETTINGS';
export const SAVE_DEAL_FILE_GROUP_ORDER_SETTINGS_SUCCESS: string = 'SAVE_DEAL_FILE_GROUP_ORDER_SETTINGS_SUCCESS';
export const SAVE_DEAL_FILE_GROUP_ORDER_SETTINGS_ERROR: string = 'SAVE_DEAL_FILE_GROUP_ORDER_SETTINGS_ERROR';

export const SAVE_DEAL_TERM_GROUP_ORDER_SETTINGS: string = 'SAVE_DEAL_TERM_GROUP_ORDER_SETTINGS';
export const SAVE_DEAL_TERM_GROUP_ORDER_SETTINGS_SUCCESS: string = 'SAVE_DEAL_TERM_GROUP_ORDER_SETTINGS_SUCCESS';
export const SAVE_DEAL_TERM_GROUP_ORDER_SETTINGS_ERROR: string = 'SAVE_DEAL_TERM_GROUP_ORDER_SETTINGS_ERROR';

export const SAVE_ACCOUNT_SETTINGS: string = 'SAVE_ACCOUNT_SETTINGS';
export const SAVE_ACCOUNT_SETTINGS_SUCCESS: string = 'SAVE_ACCOUNT_SETTINGS_SUCCESS';
export const SAVE_ACCOUNT_SETTINGS_ERROR: string = 'SAVE_ACCOUNT_SETTINGS_ERROR';

export const SAVE_NOTIFICATION_SETTINGS: string = 'SAVE_NOTIFICATION_SETTINGS';
export const SAVE_NOTIFICATION_SETTINGS_SUCCESS: string = 'SAVE_NOTIFICATION_SETTINGS_SUCCESS';
export const SAVE_NOTIFICATION_SETTINGS_ERROR: string = 'SAVE_NOTIFICATION_SETTINGS_ERROR';

export const SAVE_PROFILE_SETTINGS: string = 'SAVE_PROFILE_SETTINGS';
export const SAVE_PROFILE_SETTINGS_SUCCESS: string = 'SAVE_PROFILE_SETTINGS_SUCCESS';
export const SAVE_PROFILE_SETTINGS_ERROR: string = 'SAVE_PROFILE_SETTINGS_ERROR';

export const SAVE_SECURITY_SETTINGS: string = 'SAVE_SECURITY_SETTINGS';
export const SAVE_SECURITY_SETTINGS_SUCCESS: string = 'SAVE_SECURITY_SETTINGS_SUCCESS';
export const SAVE_SECURITY_SETTINGS_ERROR: string = 'SAVE_SECURITY_SETTINGS_ERROR';

export const SAVE_ACCOUNT_LIST_DATA: string = 'SAVE_ACCOUNT_LIST_DATA';
export const SAVE_ACCOUNT_LIST_DATA_SUCCESS: string = 'SAVE_ACCOUNT_LIST_DATA_SUCCESS';
export const SAVE_ACCOUNT_LIST_DATA_ERROR: string = 'SAVE_ACCOUNT_LIST_DATA_ERROR';

export const SAVE_DEAL_TEMPLATE_LIST_DATA: string = 'SAVE_DEAL_TEMPLATE_LIST_DATA';
export const SAVE_DEAL_TEMPLATE_LIST_DATA_SUCCESS: string = 'SAVE_DEAL_TEMPLATE_LIST_DATA_SUCCESS';
export const SAVE_DEAL_TEMPLATE_LIST_DATA_ERROR: string = 'SAVE_DEAL_TEMPLATE_LIST_DATA_ERROR';

export const SAVE_DEAL_TEMPLATE_DATA: string = 'SAVE_DEAL_TEMPLATE_DATA';
export const SAVE_DEAL_TEMPLATE_DATA_SUCCESS: string = 'SAVE_DEAL_TEMPLATE_DATA_SUCCESS';
export const SAVE_DEAL_TEMPLATE_DATA_ERROR: string = 'SAVE_DEAL_TEMPLATE_DATA_ERROR';

export const SAVE_PORTFOLIO_GROUP_LIST_DATA: string = 'SAVE_PORTFOLIO_GROUP_LIST_DATA';
export const SAVE_PORTFOLIO_GROUP_LIST_DATA_SUCCESS: string = 'SAVE_PORTFOLIO_GROUP_LIST_DATA_SUCCESS';
export const SAVE_PORTFOLIO_GROUP_LIST_DATA_ERROR: string = 'SAVE_PORTFOLIO_GROUP_LIST_DATA_ERROR';

export const SAVE_PORTFOLIO_GROUP_DATA: string = 'SAVE_PORTFOLIO_GROUP_DATA';
export const SAVE_PORTFOLIO_GROUP_DATA_SUCCESS: string = 'SAVE_PORTFOLIO_GROUP_DATA_SUCCESS';
export const SAVE_PORTFOLIO_GROUP_DATA_ERROR: string = 'SAVE_PORTFOLIO_GROUP_DATA_ERROR';

export const SAVE_PORTFOLIO_DATA: string = 'SAVE_PORTFOLIO_DATA';
export const SAVE_PORTFOLIO_DATA_SUCCESS: string = 'SAVE_PORTFOLIO_DATA_SUCCESS';
export const SAVE_PORTFOLIO_DATA_ERROR: string = 'SAVE_PORTFOLIO_DATA_ERROR';

export const SAVE_USER_LIST_DATA: string = 'SAVE_USER_LIST_DATA';
export const SAVE_USER_LIST_DATA_SUCCESS: string = 'SAVE_USER_LIST_DATA_SUCCESS';
export const SAVE_USER_LIST_DATA_ERROR: string = 'SAVE_USER_LIST_DATA_ERROR';

export const SAVE_USER_SETTINGS_DATA: string = 'SAVE_USER_SETTINGS_DATA';
export const SAVE_USER_SETTINGS_DATA_SUCCESS: string = 'SAVE_USER_SETTINGS_DATA_SUCCESS';
export const SAVE_USER_SETTINGS_DATA_ERROR: string = 'SAVE_USER_SETTINGS_DATA_ERROR';

export const SAVE_ASSET_LIST_DATA: string = 'SAVE_ASSET_LIST_DATA';
export const SAVE_ASSET_LIST_DATA_SUCCESS: string = 'SAVE_ASSET_LIST_DATA_SUCCESS';
export const SAVE_ASSET_LIST_DATA_ERROR: string = 'SAVE_ASSET_LIST_DATA_ERROR';

export const SAVE_ASSET_DATA: string = 'SAVE_ASSET_DATA';
export const SAVE_ASSET_DATA_SUCCESS: string = 'SAVE_ASSET_DATA_SUCCESS';
export const SAVE_ASSET_DATA_ERROR: string = 'SAVE_ASSET_DATA_ERROR';

export const SAVE_ACTIVITY_LIST_DATA: string = 'SAVE_ACTIVITY_LIST_DATA';
export const SAVE_ACTIVITY_LIST_DATA_SUCCESS: string = 'SAVE_ACTIVITY_LIST_DATA_SUCCESS';
export const SAVE_ACTIVITY_LIST_DATA_ERROR: string = 'SAVE_ACTIVITY_LIST_DATA_ERROR';

export const SAVE_ACTIVITY_STATUS_LIST: string = 'SAVE_ACTIVITY_STATUS_LIST';
export const SAVE_ACTIVITY_STATUS_LIST_SUCCESS: string = 'SAVE_ACTIVITY_STATUS_LIST_SUCCESS';
export const SAVE_ACTIVITY_STATUS_LIST_ERROR: string = 'SAVE_ACTIVITY_STATUS_LIST_ERROR';

export const SAVE_ACTIVITY_LIST: string = 'SAVE_ACTIVITY_LIST';
export const SAVE_ACTIVITY_LIST_SUCCESS: string = 'SAVE_ACTIVITY_LIST_SUCCESS';
export const SAVE_ACTIVITY_LIST_ERROR: string = 'SAVE_ACTIVITY_LIST_ERROR';

export const SAVE_ACTIVITY_DATA: string = 'SAVE_ACTIVITY_DATA';
export const SAVE_ACTIVITY_DATA_SUCCESS: string = 'SAVE_ACTIVITY_DATA_SUCCESS';
export const SAVE_ACTIVITY_DATA_ERROR: string = 'SAVE_ACTIVITY_DATA_ERROR';

export const SAVE_ACTIVITY_STATUS: string = 'SAVE_ACTIVITY_STATUS';
export const SAVE_ACTIVITY_STATUS_SUCCESS: string = 'SAVE_ACTIVITY_STATUS_SUCCESS';
export const SAVE_ACTIVITY_STATUS_ERROR: string = 'SAVE_ACTIVITY_STATUS_ERROR';

export const SAVE_ACTIVITY_COMMENT: string = 'SAVE_ACTIVITY_COMMENT';
export const SAVE_ACTIVITY_COMMENT_SUCCESS: string = 'SAVE_ACTIVITY_COMMENT_SUCCESS';
export const SAVE_ACTIVITY_COMMENT_ERROR: string = 'SAVE_ACTIVITY_COMMENT_ERROR';

export const SAVE_DEAL_LIST_DATA: string = 'SAVE_DEAL_LIST_DATA';
export const SAVE_DEAL_LIST_DATA_SUCCESS: string = 'SAVE_DEAL_LIST_DATA_SUCCESS';
export const SAVE_DEAL_LIST_DATA_ERROR: string = 'SAVE_DEAL_LIST_DATA_ERROR';

export const SAVE_DEAL_LIST_FILE: string = 'SAVE_DEAL_LIST_FILE';
export const SAVE_DEAL_LIST_FILE_SUCCESS: string = 'SAVE_DEAL_LIST_FILE_SUCCESS';
export const SAVE_DEAL_LIST_FILE_ERROR: string = 'SAVE_DEAL_LIST_FILE_ERROR';

export const SAVE_DEAL_STATUS_LIST: string = 'SAVE_DEAL_STATUS_LIST';
export const SAVE_DEAL_STATUS_LIST_SUCCESS: string = 'SAVE_DEAL_STATUS_LIST_SUCCESS';
export const SAVE_DEAL_STATUS_LIST_ERROR: string = 'SAVE_DEAL_STATUS_LIST_ERROR';

export const SHARE_DEAL_DATA: string = 'SHARE_DEAL_DATA';
export const SHARE_DEAL_DATA_SUCCESS: string = 'SHARE_DEAL_DATA_SUCCESS';
export const SHARE_DEAL_DATA_ERROR: string = 'SHARE_DEAL_DATA_ERROR';

export const UPDATE_FILE_DEAL_LIST: string = 'UPDATE_FILE_DEAL_LIST';
export const UPDATE_FILE_DEAL_LIST_SUCCESS: string = 'UPDATE_FILE_DEAL_LIST_SUCCESS';
export const UPDATE_FILE_DEAL_LIST_ERROR: string = 'UPDATE_FILE_DEAL_LIST_ERROR';

export const SAVE_DEAL_DATA: string = 'SAVE_DEAL_DATA';
export const SAVE_DEAL_DATA_SUCCESS: string = 'SAVE_DEAL_DATA_SUCCESS';
export const SAVE_DEAL_DATA_ERROR: string = 'SAVE_DEAL_DATA_ERROR';

export const SAVE_DEAL_STATUS: string = 'SAVE_DEAL_STATUS';
export const SAVE_DEAL_STATUS_SUCCESS: string = 'SAVE_DEAL_STATUS_SUCCESS';
export const SAVE_DEAL_STATUS_ERROR: string = 'SAVE_DEAL_STATUS_ERROR';

export const SAVE_DEAL_VALUATION_FILE: string = 'SAVE_DEAL_VALUATION_FILE';
export const SAVE_DEAL_VALUATION_FILE_SUCCESS: string = 'SAVE_DEAL_VALUATION_FILE_SUCCESS';
export const SAVE_DEAL_VALUATION_FILE_ERROR: string = 'SAVE_DEAL_VALUATION_FILE_ERROR';

export const SAVE_DEAL_TASK_LIST: string = 'SAVE_DEAL_TASK_LIST';
export const SAVE_DEAL_TASK_LIST_SUCCESS: string = 'SAVE_DEAL_TASK_LIST_SUCCESS';
export const SAVE_DEAL_TASK_LIST_ERROR: string = 'SAVE_DEAL_TASK_LIST_ERROR';

export const SAVE_DEAL_TASK: string = 'SAVE_DEAL_TASK';
export const SAVE_DEAL_TASK_SUCCESS: string = 'SAVE_DEAL_TASK_SUCCESS';
export const SAVE_DEAL_TASK_ERROR: string = 'SAVE_DEAL_TASK_ERROR';

export const SAVE_DEAL_TASK_STATUS: string = 'SAVE_DEAL_TASK_STATUS';
export const SAVE_DEAL_TASK_STATUS_SUCCESS: string = 'SAVE_DEAL_TASK_STATUS_SUCCESS';
export const SAVE_DEAL_TASK_STATUS_ERROR: string = 'SAVE_DEAL_TASK_STATUS_ERROR';

export const SAVE_DEAL_TASK_REVIEW_STATUS: string = 'SAVE_DEAL_TASK_REVIEW_STATUS';
export const SAVE_DEAL_TASK_REVIEW_STATUS_SUCCESS: string = 'SAVE_DEAL_TASK_REVIEW_STATUS_SUCCESS';
export const SAVE_DEAL_TASK_REVIEW_STATUS_ERROR: string = 'SAVE_DEAL_TASK_REVIEW_STATUS_ERROR';

export const SAVE_DEAL_TASK_TEMPLATE_DATA: string = 'SAVE_DEAL_TASK_TEMPLATE_DATA';
export const SAVE_DEAL_TASK_TEMPLATE_DATA_SUCCESS: string = 'SAVE_DEAL_TASK_TEMPLATE_DATA_SUCCESS';
export const SAVE_DEAL_TASK_TEMPLATE_DATA_ERROR: string = 'SAVE_DEAL_TASK_TEMPLATE_DATA_ERROR';

export const LOAD_DEAL_TASK_TEMPLATE_DATA: string = 'LOAD_DEAL_TASK_TEMPLATE_DATA';
export const LOAD_DEAL_TASK_TEMPLATE_DATA_SUCCESS: string = 'LOAD_DEAL_TASK_TEMPLATE_DATA_SUCCESS';
export const LOAD_DEAL_TASK_TEMPLATE_DATA_ERROR: string = 'LOAD_DEAL_TASK_TEMPLATE_DATA_ERROR';

export const SAVE_DEAL_TASK_COMMENT: string = 'SAVE_DEAL_TASK_COMMENT';
export const SAVE_DEAL_TASK_COMMENT_SUCCESS: string = 'SAVE_DEAL_TASK_COMMENT_SUCCESS';
export const SAVE_DEAL_TASK_COMMENT_ERROR: string = 'SAVE_DEAL_TASK_COMMENT_ERROR';

export const SAVE_DEAL_FILE: string = 'SAVE_DEAL_FILE';
export const SAVE_DEAL_FILE_SUCCESS: string = 'SAVE_DEAL_FILE_SUCCESS';
export const SAVE_DEAL_FILE_ERROR: string = 'SAVE_DEAL_FILE_ERROR';

export const SAVE_DEAL_SCHEDULE: string = 'SAVE_DEAL_SCHEDULE';
export const SAVE_DEAL_SCHEDULE_SUCCESS: string = 'SAVE_DEAL_SCHEDULE_SUCCESS';
export const SAVE_DEAL_SCHEDULE_ERROR: string = 'SAVE_DEAL_SCHEDULE_ERROR';

export const SAVE_DEAL_PARTICIPANT_LIST: string = 'SAVE_DEAL_PARTICIPANT_LIST';
export const SAVE_DEAL_PARTICIPANT_LIST_SUCCESS: string = 'SAVE_DEAL_PARTICIPANT_LIST_SUCCESS';
export const SAVE_DEAL_PARTICIPANT_LIST_ERROR: string = 'SAVE_DEAL_PARTICIPANT_LIST_ERROR';

export const SAVE_DEAL_PARTICIPANT: string = 'SAVE_DEAL_PARTICIPANT';
export const SAVE_DEAL_PARTICIPANT_SUCCESS: string = 'SAVE_DEAL_PARTICIPANT_SUCCESS';
export const SAVE_DEAL_PARTICIPANT_ERROR: string = 'SAVE_DEAL_PARTICIPANT_ERROR';

export const SAVE_DEAL_PARTICIPANT_COMMENT: string = 'SAVE_DEAL_PARTICIPANT_COMMENT';
export const SAVE_DEAL_PARTICIPANT_COMMENT_SUCCESS: string = 'SAVE_DEAL_PARTICIPANT_COMMENT_SUCCESS';
export const SAVE_DEAL_PARTICIPANT_COMMENT_ERROR: string = 'SAVE_DEAL_PARTICIPANT_COMMENT_ERROR';

export const SAVE_CONTACT_LIST_DATA: string = 'SAVE_CONTACT_LIST_DATA';
export const SAVE_CONTACT_LIST_DATA_SUCCESS: string = 'SAVE_CONTACT_LIST_DATA_SUCCESS';
export const SAVE_CONTACT_LIST_DATA_ERROR: string = 'SAVE_CONTACT_LIST_DATA_ERROR';

export const SAVE_CONTACT_DATA: string = 'SAVE_CONTACT_DATA';
export const SAVE_CONTACT_DATA_SUCCESS: string = 'SAVE_CONTACT_DATA_SUCCESS';
export const SAVE_CONTACT_DATA_ERROR: string = 'SAVE_CONTACT_DATA_ERROR';

export const SAVE_CONTACT_COMMENT: string = 'SAVE_CONTACT_COMMENT';
export const SAVE_CONTACT_COMMENT_SUCCESS: string = 'SAVE_CONTACT_COMMENT_SUCCESS';
export const SAVE_CONTACT_COMMENT_ERROR: string = 'SAVE_CONTACT_COMMENT_ERROR';

export const SAVE_REPORT_DATA: string = 'SAVE_REPORT_DATA';
export const SAVE_REPORT_DATA_SUCCESS: string = 'SAVE_REPORT_DATA_SUCCESS';
export const SAVE_REPORT_DATA_ERROR: string = 'SAVE_REPORT_DATA_ERROR';

export const DELETE_ALL_NOTIFICATIONS: string = 'DELETE_ALL_NOTIFICATIONS';
export const DELETE_ALL_NOTIFICATIONS_SUCCESS: string = 'DELETE_ALL_NOTIFICATIONS_SUCCESS';
export const DELETE_ALL_NOTIFICATIONS_ERROR: string = 'DELETE_ALL_NOTIFICATIONS_ERROR';

export const DELETE_NOTIFICATION: string = 'DELETE_NOTIFICATION';
export const DELETE_NOTIFICATION_SUCCESS: string = 'DELETE_NOTIFICATION_SUCCESS';
export const DELETE_NOTIFICATION_ERROR: string = 'DELETE_NOTIFICATION_ERROR';

export const DELETE_ACCOUNT: string = 'DELETE_ACCOUNT';
export const DELETE_ACCOUNT_SUCCESS: string = 'DELETE_ACCOUNT_SUCCESS';
export const DELETE_ACCOUNT_ERROR: string = 'DELETE_ACCOUNT_ERROR';

export const DELETE_DEAL_TEMPLATE: string = 'DELETE_DEAL_TEMPLATE';
export const DELETE_DEAL_TEMPLATE_SUCCESS: string = 'DELETE_DEAL_TEMPLATE_SUCCESS';
export const DELETE_DEAL_TEMPLATE_ERROR: string = 'DELETE_DEAL_TEMPLATE_ERROR';

export const DELETE_PORTFOLIO_GROUP: string = 'DELETE_PORTFOLIO_GROUP';
export const DELETE_PORTFOLIO_GROUP_SUCCESS: string = 'DELETE_PORTFOLIO_GROUP_SUCCESS';
export const DELETE_PORTFOLIO_GROUP_ERROR: string = 'DELETE_PORTFOLIO_GROUP_ERROR';

export const DELETE_PORTFOLIO_GROUP_PORTFOLIO: string = 'DELETE_PORTFOLIO_GROUP_PORTFOLIO';
export const DELETE_PORTFOLIO_GROUP_PORTFOLIO_SUCCESS: string = 'DELETE_PORTFOLIO_GROUP_PORTFOLIO_SUCCESS';
export const DELETE_PORTFOLIO_GROUP_PORTFOLIO_ERROR: string = 'DELETE_PORTFOLIO_GROUP_PORTFOLIO_ERROR';

export const DELETE_USER: string = 'DELETE_USER';
export const DELETE_USER_SUCCESS: string = 'DELETE_USER_SUCCESS';
export const DELETE_USER_ERROR: string = 'DELETE_USER_ERROR';

export const DELETE_ASSET_LIST: string = 'DELETE_ASSET_LIST';
export const DELETE_ASSET_LIST_SUCCESS: string = 'DELETE_ASSET_LIST_SUCCESS';
export const DELETE_ASSET_LIST_ERROR: string = 'DELETE_ASSET_LIST_ERROR';

export const DELETE_PORTFOLIO: string = 'DELETE_PORTFOLIO';
export const DELETE_PORTFOLIO_SUCCESS: string = 'DELETE_PORTFOLIO_SUCCESS';
export const DELETE_PORTFOLIO_ERROR: string = 'DELETE_PORTFOLIO_ERROR';

export const DELETE_ACTIVITY_LIST: string = 'DELETE_ACTIVITY_LIST';
export const DELETE_ACTIVITY_LIST_SUCCESS: string = 'DELETE_ACTIVITY_LIST_SUCCESS';
export const DELETE_ACTIVITY_LIST_ERROR: string = 'DELETE_ACTIVITY_LIST_ERROR';

export const DELETE_ACTIVITY_COMMENT: string = 'DELETE_ACTIVITY_COMMENT';
export const DELETE_ACTIVITY_COMMENT_SUCCESS: string = 'DELETE_ACTIVITY_COMMENT_SUCCESS';
export const DELETE_ACTIVITY_COMMENT_ERROR: string = 'DELETE_ACTIVITY_COMMENT_ERROR';

export const DELETE_DEAL_LIST: string = 'DELETE_DEAL_LIST';
export const DELETE_DEAL_LIST_SUCCESS: string = 'DELETE_DEAL_LIST_SUCCESS';
export const DELETE_DEAL_LIST_ERROR: string = 'DELETE_DEAL_LIST_ERROR';

export const DELETE_DEAL_VALUATION_FILE: string = 'DELETE_DEAL_VALUATION_FILE';
export const DELETE_DEAL_VALUATION_FILE_SUCCESS: string = 'DELETE_DEAL_VALUATION_FILE_SUCCESS';
export const DELETE_DEAL_VALUATION_FILE_ERROR: string = 'DELETE_DEAL_VALUATION_FILE_ERROR';

export const DELETE_DEAL_TASK_GROUP: string = 'DELETE_DEAL_TASK_GROUP';
export const DELETE_DEAL_TASK_GROUP_SUCCESS: string = 'DELETE_DEAL_TASK_GROUP_SUCCESS';
export const DELETE_DEAL_TASK_GROUP_ERROR: string = 'DELETE_DEAL_TASK_GROUP_ERROR';

export const DELETE_DEAL_TASK_LIST: string = 'DELETE_DEAL_TASK_LIST';
export const DELETE_DEAL_TASK_LIST_SUCCESS: string = 'DELETE_DEAL_TASK_LIST_SUCCESS';
export const DELETE_DEAL_TASK_LIST_ERROR: string = 'DELETE_DEAL_TASK_LIST_ERROR';

export const DELETE_DEAL_TASK_COMMENT: string = 'DELETE_DEAL_TASK_COMMENT';
export const DELETE_DEAL_TASK_COMMENT_SUCCESS: string = 'DELETE_DEAL_TASK_COMMENT_SUCCESS';
export const DELETE_DEAL_TASK_COMMENT_ERROR: string = 'DELETE_DEAL_TASK_COMMENT_ERROR';

export const DELETE_DEAL_FILE_GROUP: string = 'DELETE_DEAL_FILE_GROUP';
export const DELETE_DEAL_FILE_GROUP_SUCCESS: string = 'DELETE_DEAL_FILE_GROUP_SUCCESS';
export const DELETE_DEAL_FILE_GROUP_ERROR: string = 'DELETE_DEAL_FILE_GROUP_ERROR';

export const DELETE_DEAL_FILE_LIST: string = 'DELETE_DEAL_FILE_LIST';
export const DELETE_DEAL_FILE_LIST_SUCCESS: string = 'DELETE_DEAL_FILE_LIST_SUCCESS';
export const DELETE_DEAL_FILE_LIST_ERROR: string = 'DELETE_DEAL_FILE_LIST_ERROR';

export const DELETE_DEAL_TERM_GROUP: string = 'DELETE_DEAL_TERM_GROUP';
export const DELETE_DEAL_TERM_GROUP_SUCCESS: string = 'DELETE_DEAL_TERM_GROUP_SUCCESS';
export const DELETE_DEAL_TERM_GROUP_ERROR: string = 'DELETE_DEAL_TERM_GROUP_ERROR';

export const DELETE_DEAL_TERM: string = 'DELETE_DEAL_TERM';
export const DELETE_DEAL_TERM_SUCCESS: string = 'DELETE_DEAL_TERM_SUCCESS';
export const DELETE_DEAL_TERM_ERROR: string = 'DELETE_DEAL_TERM_ERROR';

export const DELETE_DEAL_SCHEDULE: string = 'DELETE_DEAL_SCHEDULE';
export const DELETE_DEAL_SCHEDULE_SUCCESS: string = 'DELETE_DEAL_SCHEDULE_SUCCESS';
export const DELETE_DEAL_SCHEDULE_ERROR: string = 'DELETE_DEAL_SCHEDULE_ERROR';

export const DELETE_DEAL_PARTICIPANT_LIST: string = 'DELETE_DEAL_PARTICIPANT_LIST';
export const DELETE_DEAL_PARTICIPANT_LIST_SUCCESS: string = 'DELETE_DEAL_PARTICIPANT_LIST_SUCCESS';
export const DELETE_DEAL_PARTICIPANT_LIST_ERROR: string = 'DELETE_DEAL_PARTICIPANT_LIST_ERROR';

export const DELETE_DEAL_PARTICIPANT_COMMENT: string = 'DELETE_DEAL_PARTICIPANT_COMMENT';
export const DELETE_DEAL_PARTICIPANT_COMMENT_SUCCESS: string = 'DELETE_DEAL_PARTICIPANT_COMMENT_SUCCESS';
export const DELETE_DEAL_PARTICIPANT_COMMENT_ERROR: string = 'DELETE_DEAL_PARTICIPANT_COMMENT_ERROR';

export const DELETE_CONTACT_LIST: string = 'DELETE_CONTACT_LIST';
export const DELETE_CONTACT_LIST_SUCCESS: string = 'DELETE_CONTACT_LIST_SUCCESS';
export const DELETE_CONTACT_LIST_ERROR: string = 'DELETE_CONTACT_LIST_ERROR';

export const DELETE_CONTACT_COMMENT: string = 'DELETE_CONTACT_COMMENT';
export const DELETE_CONTACT_COMMENT_SUCCESS: string = 'DELETE_CONTACT_COMMENT_SUCCESS';
export const DELETE_CONTACT_COMMENT_ERROR: string = 'DELETE_CONTACT_COMMENT_ERROR';

export const DELETE_REPORT: string = 'DELETE_REPORT';
export const DELETE_REPORT_SUCCESS: string = 'DELETE_REPORT_SUCCESS';
export const DELETE_REPORT_ERROR: string = 'DELETE_REPORT_ERROR';
